import { HotelBookings } from "../Hotels/Item"
import { IHotelGroup } from "./store"

export function HotelGroupBookings({ group }: { group: IHotelGroup }) {
	return <HotelBookings params={{ hotel_groups: [group.id] }} />
}
